<template>
  <div class="card mb-2">
    <div class="card-header">
      <div class="col-md-12 pl-0">
        <el-radio-group
          v-model="type"
          fill="#5e72e4"
          @change="handleTransactionTypeChange"
        >
          <el-radio-button
            v-for="(item, index) in selectOptions"
            :label="item.value"
            :key="index"
            >{{ item.label }}</el-radio-button
          >
        </el-radio-group>
        <div v-if="type === 'quote'">
          <el-radio
            :disabled="
              $route.meta.mode === 'edit-user-quotation' ||
              $route.meta.mode === 'edit-quote'
                ? true
                : false
            "
            v-model="quotationUser"
            label="customer"
            >Customer</el-radio
          >
          <el-radio
            v-model="quotationUser"
            :disabled="
              $route.meta.mode === 'edit-user-quotation' ||
              $route.meta.mode === 'edit-quote'
                ? true
                : false
            "
            label="serviceRequest"
            >Service Request</el-radio
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  Radio,
  RadioGroup,
  RadioButton,
  Table,
  TableColumn,
  Autocomplete,
  DatePicker,
  Dialog,
  Form
} from "element-ui";
export default {
  props: {
    transactionType: {
      type: String,
      default: "sale"
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Autocomplete.name]: Autocomplete,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Form.name]: Form
  },
  data: () => {
    return {
      type: "sale",
      quotationUser: "customer",
      selectOptions: [
        {
          label: "Sale",
          value: "sale"
        },
        {
          label: "Quote",
          value: "quote"
        },
        {
          label: "Chalan",
          value: "chalan"
        }
      ]
    };
  },
  methods: {
    handleTransactionTypeChange() {
      this.$emit("onTypeChange", this.type);
    }
  }
};
</script>
